import createAction from '../../app/createAction';
import { SET_IS_FIRST_SHOW_INTRO, SHOW_WATCH_MORE_VIDEOS_LATER_TOOLTIP } from './tutorialsConstants';

export const showWatchMoreVideosLaterTooltipAction = (payload) =>
    createAction(SHOW_WATCH_MORE_VIDEOS_LATER_TOOLTIP, payload);

export const setIsFirstShowIntro = (payload) => createAction(SET_IS_FIRST_SHOW_INTRO, payload);
